<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-inside: avoid;text-align: center;margin: 0;">
<a href="https://earlybirdbooks.com/freebook/index.html?q=66cf1e13c4580db37c5e61cb&amp;utm_campaign=front" target="_blank">
<img alt="image" src="xhtml/love.jpg" style="max-width:100%;max-height:100%;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// love_1.vue?b8a4c51e